<template>
  <div class="index">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image fit="cover" :src="require('./../assets/img/banner3.jpg')" />
      </van-swipe-item>
    </van-swipe>



    <h2 class="doc_title">用户绑定</h2>


    <div class="van-doc-demo-block__card">
<!--      <van-cell  title="当前用户" is-link v-model="c_user" @click="onChooseCustomer" />-->

      <van-cell center :title="C_Name" is-link value="去绑定" to="bindlist" :label="C_Address" />
    </div>


<!--    <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '40%' }"
    >
      <div>
        <nut-cell title="请选择当前已绑定的燃气用户">
        </nut-cell>
        <van-list >
          <van-cell v-for="(item, index) in list" :key="item.id" >
            &lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;
            <template #title>
              <span class="custom-title" @click="onItemClick(item.C_ID,item.C_Name,item.C_Address)">{{item.C_Name}}-{{item.C_Address}}</span>
            </template>
            <template #extra>
              <van-button type="warning" size="small" @click="delItem(index)">解绑</van-button>
            </template>
          </van-cell>
        </van-list>
        <div style="margin: 16px;">
          <van-button round block type="info" @click="bindWX">绑定更多</van-button>
        </div>
      </div>

    </van-popup>-->



    <h2 class="doc_title">燃气业务</h2>

    <div class="van-doc-demo-block__card">

      <van-grid square clickable :column-num="4">
        <van-grid-item :icon="require('./../assets/img/premoney.png')" text="气费充值"  to="/ycqf" />
        <van-grid-item :icon="require('./../assets/img/premoney_his.png')" text="充值记录"  to="/ycjl" />
        <van-grid-item :icon="require('./../assets/img/pay_fee.png')" text="欠费缴费" to="/qfjl" />
        <van-grid-item :icon="require('./../assets/img/fee_his.png')" text="缴费记录" to="/jfjl" />
        <van-grid-item :icon="require('./../assets/img/common_fee.png')" text="一般收费"  to="/ybsf" />
        <van-grid-item :icon="require('./../assets/img/fee_analysis.png')" text="用气分析" to="/yqfx" />
        <van-grid-item :icon="require('./../assets/img/gas_price.png')" text="气价公示" to="/gasprice"/>
        <van-grid-item :icon="require('./../assets/img/gas_quality.png')" text="燃气质量" to="/gasquality" />


      </van-grid>

    </div>


    <h2 class="doc_title">综合信息</h2>


    <div class="van-doc-demo-block__card">

      <van-grid square clickable :column-num="4">
        <van-grid-item :icon="require('./../assets/img/business_guide.png')" text="业务指南" to="/businessguide" />
        <van-grid-item :icon="require('./../assets/img/memo.png')" text="装修须知"  to="/memo" />
        <van-grid-item :icon="require('./../assets/img/wangdian.png')" text="网点信息" to="/wangdian"  />
        <van-grid-item :icon="require('./../assets/img/company_info.png')" text="公司概况"  to="/companyinfo" />
      </van-grid>

    </div>

    <van-divider/>

    <div class="footer">
      <p>本服务由江山市江城管道燃气有限公司提供</p>
      <p>服务热线：<a href="tel:4008265999">400-826-5999</a>按2供气服务</p>
    </div>

  </div>
</template>
<script>
  import { Toast } from 'vant';
  import API from "@/api";
  export default {
    name: 'page_index',
    data() {
      return {
        C_ID:"",
        C_Address:"",
        C_Name:"",
        list: ""
      };
    },
    methods: {
      onClickLeft() {
        Toast('返回');
      },
      getUser(){
        this.$http.get(API.LookCustByOpenID)
            .then((response)=>{
              let res =response.data;
              if (res.code===0) {
                if (res.count===0) {
                  //Toast('1');
                  //this.$router.push('/searchcust');

                  this.C_ID = '';
                  this.C_Name = '未绑定';
                  this.C_Address = '';
                  this.$cookie.set('CID','',  { expires: '360m' });
                  this.$cookie.set('CName','未绑定',  { expires: '360m' });
                  this.$cookie.set('CAddress','',  { expires: '360m' });
                  this.$cookie.set('C_Code','',  { expires: '360m' });
                } else {
                  this.list=res.subdata;
                  this.$cookie.set('CustArray',res.subdata,  { expires: '360m' });

                  if (this.$cookie.get('CID')===''||!this.$cookie.get('CID')) {
                    //Toast('2');
                    this.C_ID = res.subdata[0].C_ID;
                    this.C_Name = res.subdata[0].C_Name;
                    this.C_Address = res.subdata[0].C_Address;
                    this.$cookie.set('CID',res.subdata[0].C_ID,  { expires: '360m' });
                    this.$cookie.set('CName',res.subdata[0].C_Name,  { expires: '360m' });
                    this.$cookie.set('CAddress',res.subdata[0].C_Address,  { expires: '360m' });
                    this.$cookie.set('C_Code',res.subdata[0].C_Code,  { expires: '360m' });
                  } else  {
                    //Toast('3');
                    /*this.$cookie.set('CID',res.subdata[0].C_ID,  { expires: '360m' });
                    this.$cookie.set('CName',res.subdata[0].C_Name,  { expires: '360m' });
                    this.$cookie.set('CAddress',res.subdata[0].C_Address,  { expires: '360m' });
                    this.$cookie.set('C_Code',res.subdata[0].C_Code,  { expires: '360m' });*/
                    this.C_ID = this.$cookie.get('CID');
                    this.C_Name =  this.$cookie.get('CName');
                    this.C_Address =  this.$cookie.get('CAddress');
                  }
                }
              }
            })
      },
    },
    mounted() {
      this.getUser();
    }
  }
</script>
<style>
  .index{
    height: 100vh;
    background-color: #f5f5f5;
  }
  .my-swipe {
    line-height: 30px;
  }
  .van-doc-demo-block__card {
    margin: 16px 12px 0px;
    overflow: hidden;
    border-radius: 8px;
  }
  .doc_title {
    margin: 0;
    padding: 22px 16px 0px 16px;
    color: rgba(69, 90, 100, 0.6);
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #e0e0e0;
    padding: 10px 20px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .footer a {
    color: #1989fa;
    text-decoration: none;
  }
</style>